import { Message } from 'element-ui';
import axios from 'axios';
import qs from 'qs';
import { getToken, removeToken } from '@/utils';
import envConfig from '../../config';

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];
const authURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_AUTH_URL`];

const instance = axios.create({
  baseURL,
  timeout: 300000,
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  },
});

instance.interceptors.request.use((request) => {
  /* eslint-disable */
  const { pathParams } = request;
  let newUrl = request.url;
  if (pathParams && pathParams instanceof Object) {
    Object.keys(pathParams).forEach((name) => {
      newUrl = newUrl.replace(`\:${name}`, pathParams[name]);
    });
  }

  if (request.method.toUpperCase() === 'POST' && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    request.data = qs.stringify(request.data || {});
  }
  request.url = newUrl;
  return request;
});

if (envConfig.env === 'development') {
  // instance.interceptors.request.use((request) => {
  //   request.baseURL += `/${request.method}`;
  //   return request;
  // });
  instance.interceptors.response.use((response) => {
    /* eslint-disable no-console */
    console.log(`请求${response.config.url.replace(new RegExp(response.config.baseURL), '')}返回的Mock数据:`);
    console.dir(response.data);
    return response;
  });
}

instance.interceptors.request.use((request) => {
  /* eslint-disable */
  const ticket = getToken();
  if (ticket) {
    request.headers.common['Authorization'] = `Bearer ${ticket}`;
  }
  request.headers.common['version'] = envConfig.version;
  request.withCredentials = true;
  /* eslint-enable */
  return request;
});
instance.interceptors.response.use(
  async (response) => {
    // 拦截数据导出统一提示
    if (response.data instanceof Blob) {
      if (response.data.type === 'application/octet-stream' || response.data.type === 'application/ms-excel') {
        const origin = response.headers['content-disposition'];
        const originFilename = origin.split('; ').filter((ele) => ele.indexOf('filename') !== -1);
        let filename = '';
        if (originFilename && originFilename.length > 0) {
          // filename = new String(originFilename[0].split('=')[1].replace(/"/g, '').getBytes('ISO-8859-1'), 'UTF-8');
          filename = originFilename[0].split('=')[1].replace(/"/g, '');
        }
        return {
          blob: response.data,
          filename,
        };
      }
      // 默认导出错误提示
      let exportErrorMsg = '导出失败';

      // 导出失败，转换为JSON
      const fr = new FileReader();
      fr.readAsText(response.data, 'utf-8');
      fr.onload = function onload() {
        try {
          exportErrorMsg = JSON.parse(this.result).msg;
        } catch (e) {
          console.log(e);
          throw e;
        } finally {
          Message.error({
            content: exportErrorMsg,
            duration: 5,
          });
        }
      };
      fr.onerror = function onerror() {
        Message.error({
          content: exportErrorMsg,
          duration: 5,
        });
      };

      return Promise.reject();
    }
    // 阻止options
    if (response.config.method.toLowerCase() === 'options') return false;
    // 阻止非登录失效状态
    if ([302, 401].some((status) => status === response.status)) {
      window.location.href = `${authURL}/riskcontrol/oauth/login?redirect=${window.location.protocol}//${window.location.host}`;
      return Promise.reject();
    }
    // 阻止非200状态
    if (response.status !== 200) return Promise.reject();

    // 目前后端组规范将所有请求统一返回200，以code字段表示真实http状态码
    // warning 智能云后台默认成功请求时返回code:0  权限管理系统则返回code:200  可以用response.request.url区分, 现在先偷懒
    const { to } = response.config;
    const meta = (to || {}).meta || {};
    // 无需登录,返回response.data：meth.auth===0||response.data.code不在权限状态码名单之内
    if (meta.auth === 0 || ![401].some((itemCode) => itemCode === response.data.code)) {
      return response.data;
    }

    // 移除token,调用登录
    removeToken();
    window.location.href = `${authURL}/riskcontrol/oauth/login?redirect=${window.location.protocol}//${window.location.host}`;
    // await store.dispatch('user/LogOut', 'local');
    return Promise.reject(response);
  },
  (error) => {
    console.log(error);
    Message.error({
      content: '操作失败',
      duration: 3,
    });
    return Promise.reject(error);
  }
);

export default instance;
